/* 

This file is all about getting a refresh token.

It will almost always be triggered when:

    a) the API returns a 401; or
    b) the refresh token in local storage has expired; and
    c) in either case, there is a valid refresh token in local storage.

*/

import jsonwebtoken from 'jsonwebtoken';

export default async function getRefreshToken(apiBaseUrl) {
  const REFRESH_URL = `${apiBaseUrl}/refresh`;
  const PK_URL = `${apiBaseUrl}/.well-known/jwpub.pem`;
  let pubKeyStr = sessionStorage.getItem('PUBLIC_KEY');
  let claims;

  const refreshToken = localStorage.getItem('REFRESH_TOKEN');
  if (refreshToken === null) {
    // There is no token in local storage; we can't refresh
    return false;
  }

  // Get public key
  if (pubKeyStr == null) {
    const pubKeyReq = await fetch(PK_URL, {
      method: 'GET',
      cache: 'no-store',
    }).catch(() => {
      return false;
    });
    pubKeyStr = await pubKeyReq.text();
    sessionStorage.setItem('PUBLIC_KEY', pubKeyStr);
  }

  try {
    claims = jsonwebtoken.verify(refreshToken, pubKeyStr, {
      algorithms: ['RS256'],
      issuer: 'ptu-hub-api',
    });
  } catch (e) {
    return false;
  }

  const authTokenReq = await fetch(REFRESH_URL, {
    method: 'POST',
    body: JSON.stringify({ token: refreshToken }),
    headers: { 'Content-type': 'application/json;charset=UTF-8' },
    cache: 'no-store',
  });

  let newToken;
  if (authTokenReq.status !== 200) {
    return false;
  }

  newToken = await authTokenReq.json();
  newToken = newToken.token;

  try {
    claims = jsonwebtoken.verify(newToken, pubKeyStr, {
      algorithms: ['RS256'],
      issuer: 'ptu-hub-api',
    });
  } catch (e) {
    return false;
  }

  if (claims.type !== 'auth') {
    return false;
  }

  sessionStorage.setItem('AUTH_TOKEN', newToken);
  sessionStorage.setItem('CLAIMS', JSON.stringify(claims));
  return true;
}
